export const ROLE_OPTIONS = [
  {
    value: "owner",
    label: "Admin",
    description: "Her şeye ve tüm şubelere erişir",
  },
  {
    value: "member",
    label: "Şube kullanıcısı",
    description:
      "Seçtiğin şubelerde seçtiğin ekranları görür; gördüğü ekranda her işlemi yapabilir",
  },
];

export const ROLE_LABELS = Object.fromEntries(
  ROLE_OPTIONS.map((role) => [role.value, role.label]),
);

export const AREA_OPTIONS = [
  {
    value: "overview",
    label: "Genel Bakış",
    description: "Ciro ve ürün satışları",
  },
  {
    value: "categories",
    label: "Kategoriler",
    description: "Kategoriler ve şubede görünürlükleri",
  },
  {
    value: "products",
    label: "Ürünler",
    description: "Ürünler, fiyatlar ve şube fiyatları",
  },
  {
    value: "branches",
    label: "Şubeler",
    description: "Şube bilgileri, bağlantıları ve menü sırası",
  },
  {
    value: "connections",
    label: "Entegrasyonlar",
    description: "Kanal bağlantıları ve fiyat gönderimi",
  },
  {
    value: "bulk",
    label: "Toplu İşlemler",
    description: "Excel ile toplu fiyat güncelleme",
  },
  {
    value: "supply",
    label: "İkmal Talepleri",
    description: "Merkezden talep açma ve teslim alma",
  },
  {
    value: "supply_center",
    label: "İkmal Merkezi",
    description: "Talepleri onaylama, sevk, kalem ve stok",
  },
  {
    value: "settings",
    label: "Ayarlar",
    description: "Marka, menü dilleri ve görseller",
  },
];

export const AREA_LABELS = Object.fromEntries(
  AREA_OPTIONS.map((area) => [area.value, area.label]),
);

export const ADMIN_ONLY = "admin";

// Kilitli kontrollerin tooltip'i. Yetkisiz kullanıcıda buton gizlenmiyor, disabled bırakılıyor —
// böylece satır düzeni herkeste aynı kalıyor ve kullanıcı işlemin var olduğunu ama kendisine
// kapalı olduğunu görüyor.
export const NO_PERMISSION_HINT = "Bu işlem için yetkin yok";

// Yetkiye bağlı bir kontrolün disabled + title'ı. `disabled` yetkiden bağımsız ikinci bir sebep
// için (zaten hepsi açık, liste boş vb.), `title` yetkili durumdaki normal ipucu.
export const lockProps = (allowed, { title, disabled = false } = {}) => ({
  disabled: !allowed || disabled,
  title: allowed ? title : NO_PERMISSION_HINT,
});

export const PAGE_AREAS = {
  "/": ["overview"],
  "/categories": ["categories"],
  "/products": ["products"],
  "/branches": ["branches"],
  "/connections": ["connections"],
  "/bulk": ["bulk"],
  "/supply": ["supply", "supply_center"],
  "/supply/items": ["supply_center"],
  "/settings": ["settings"],
  "/users": [ADMIN_ONLY],
};

export const landingPageFor = (canAny) =>
  Object.keys(PAGE_AREAS).find((path) => canAny(PAGE_AREAS[path])) ?? null;
